import { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import styles from './headerStyles'
import { IconButton, Tooltip } from '@mui/material'
import BreakModal from './BreakModal'
import LockResetIcon from '@mui/icons-material/LockReset'
import { reducerContext } from "../../../contextApi's/contextApi's"
import messageHandler from '../../../helpers/messageHandler'
import handleLogout from '../../../helpers/handleLogout'
import snackError from "../../../helpers/snackError" 

import Frame1 from '../../../ui-assets/Frame1.svg'
import Frame2 from '../../../ui-assets/Frame2.svg'
import Frame3 from '../../../ui-assets/Frame3.svg'
import Frame4 from '../../../ui-assets/Frame4.svg'
import Frame5 from '../../../ui-assets/Frame5.svg'
import ResetPassword from './ResetPassword'
const SipStatus = ({ classes }) => {

    const navigate = useNavigate()

    const { state, dispatch } = useContext(reducerContext)
    const { sipStatus, agentHangUp, tokenValid } = state

    console.log("yessss",tokenValid)

    const [sipRegStatus, setSipRegStatus] = useState('')
    const [sipSessionStatus, setSipSessionStatus] = useState('')
    const [sipIncomingMessages, setSipIncomingMessages] = useState('')
    const [socketConStatus, setSocketConStatus] = useState('')
    const [drawOpen, setDrawOpen] = useState(false)
    // Accessing updating values of DOM elements
    // useEffect(() => {
    //     const ids = ['SIP_REG_STATUS', 'SIP_SESSION_STATUS', 'SIP_INCOMMING_MESSAGES', 'SOCKET_CON_STATUS']
    //     const stateSetters = [setSipRegStatus, setSipSessionStatus, setSipIncomingMessages, setSocketConStatus]
    //     const elements = ids.map(id => document.getElementById(id))

    //     let lastCallStatus = ''

    //     const observers = elements.map((element, index) => {
    //         if (element) {
    //             stateSetters[index](element.value)

    //             // code updated for SIP_INCOMMING_MESSAGES - dev srini - 06-11-24 
    //             const observer = new MutationObserver(mutationsList => {
    //                 for (let mutation of mutationsList) {
    //                     if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
    //                         const value = element.value

    //                         if (value) {
    //                             // Only parse values for SIP_SESSION_STATUS (index 1) and SIP_INCOMMING_MESSAGES (index 2)
    //                             if (index === 1 || index === 2) {
    //                                 try {
    //                                     const newValue = JSON.parse(value)

    //                                     // Handle SIP_INCOMMING_MESSAGES specifically
    //                                     if (index === 2) {
    //                                         if (newValue.call_status !== lastCallStatus) {
    //                                             lastCallStatus = newValue.call_status
    //                                             stateSetters[index](newValue)
    //                                         }
    //                                     } else {
    //                                         // Handle SIP_SESSION_STATUS
    //                                         stateSetters[index](newValue)
    //                                     }
    //                                 } catch (error) {
    //                                     console.log('Error parsing JSON:', error)
    //                                 }
    //                             } else {
    //                                 // For SIP_REG_STATUS and SOCKET_CON_STATUS, just set the value directly
    //                                 stateSetters[index](value) // Use raw value, no parsing needed
    //                             }
    //                         }
    //                     }
    //                 }
    //             })
    //             observer.observe(element, { attributes: true })

    //             return observer
    //         }
    //         return null
    //     })

    //     // Cleanup function to disconnect observers when the component unmounts
    //     return () => {
    //         observers.forEach(observer => {
    //             if (observer) {
    //                 observer.disconnect()
    //             }
    //         })
    //     }
    // }, [])

    const handleLogout=()=>{
        localStorage.clear()
        dispatch({ type: 'SET_TOKEN_VAL', payload: '' })
        dispatch({ type: 'USER_SIGN_IN', payload: false });
        dispatch({
            type: 'SET_SHOW_ERROR',
            payload: true
        })

        dispatch({
            type: 'SET_ERROR',
            payload: 'Unregistered successfully.'
        })

        dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc })
        navigate("/")
        
    }
    // Setting up an agent status
    // useEffect(() => {
    //     if (socketConStatus === 'connected') {
    //         dispatch({
    //             type: 'SET_SOC_STATS_MSG',
    //             payload: socketConStatus
    //         })

    //         if (sipRegStatus === 'registered') {
    //             dispatch({
    //                 type: 'SET_SIP_STATUS',
    //                 payload: true
    //             })
    //             // notifying sip register status - 07/10/24 - dev srini 
    //             dispatch({
    //                 type: 'SET_SHOW_ERROR',
    //                 payload: true
    //             })

    //             dispatch({
    //                 type: 'SET_ERROR',
    //                 payload: 'Registered'
    //             })

    //             dispatch({
    //                 type: 'SET_SIP_REG_STATS_MSG',
    //                 payload: sipRegStatus
    //             })
    //         }
    //         else {
    //             dispatch({
    //                 type: 'SET_SIP_STATUS',
    //                 payload: false
    //             })

    //             dispatch({
    //                 type: 'SET_SIP_REG_STATS_MSG',
    //                 payload: sipRegStatus
    //             })

    //             console.log('User Not Registered Yet')
    //             return
    //         }
    //     }
    //     else {
    //         dispatch({
    //             type: 'SET_SOC_STATS_MSG',
    //             payload: socketConStatus
    //         })

    //         console.log('Socket Not Connected Yet')
    //         return
    //     }

    // }, [socketConStatus, sipRegStatus])


    // Checking sip related status & messages - dev Srini - 05/11/24 
    // useEffect(() => {
    //     if (socketConStatus) {
    //         console.log(socketConStatus, 'Socket Connection Status')
    //     }

    //     if (sipRegStatus) {
    //         console.log(sipRegStatus, 'SIP Reg Status')
    //     }

    //     if (sipSessionStatus) {
    //         console.log(sipSessionStatus, 'SIP Session Status')
    //     }

    //     if (sipIncomingMessages) {
    //         console.log(sipIncomingMessages, 'SIP Incoming Messages')
    //     }

    // }, [sipRegStatus, sipSessionStatus, sipIncomingMessages, socketConStatus])

    // useEffect(() => {
    //     // srini - 14/11/24
    //     if (sipIncomingMessages) {
    //         messageHandler(sipIncomingMessages, sipSessionStatus, dispatch, agentHangUp)
    //     }

    // }, [sipIncomingMessages, sipSessionStatus, dispatch])

    // On page reload calling sip publish function
    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    // useEffect(() => {
    //     if (sipStatus) {
    //         const publishSipStatus = async () => {
    //             try {
    //                 await window.sipPublish('open', 'Idle', 'I am Idle')
    //                 console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

    //                 dispatch({
    //                     type: 'SET_AGENT_PUBLISH_STATS',
    //                     payload: 'open'
    //                 })
    //             }
    //             catch (error) {
    //                 console.error('Failed to publish SIP status:', error)
    //             }
    //         }

    //         publishSipStatus()
    //     }
    // }, [sipStatus])

    //  outgoing call didn't pick up clear dail number - Dev Srini 05/11/24
    // useEffect(() => {
    //     const status = localStorage.getItem('outgoingStatus')
    //     if (status) {

    //         dispatch({
    //             type: 'SET_CUSTOMER_PHONE_NUMBER',
    //             payload: ''
    //         })
    //         // srini - 14/11/24
    //         try {
    //             window.sipPublish('open', 'Idle', 'I am Idle')
    //             console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

    //             dispatch({
    //                 type: 'SET_AGENT_PUBLISH_STATS',
    //                 payload: 'open'
    //             })
    //         }
    //         catch (error) {
    //             console.error('Failed to publish SIP status:', error)
    //         }

    //         localStorage.removeItem('outgoingStatus')
    //     }

    // }, [sipIncomingMessages])
    // srini - 14/11/24
    // useEffect(() => {
    //     let timeoutId

    //     if (sipIncomingMessages?.call_status === "HANGUP") {
    //         timeoutId = setTimeout(() => {
    //             setSipIncomingMessages("")
    //             setSipSessionStatus("")
    //         }, 3000)
    //     }

    //     return () => clearTimeout(timeoutId)
    // }, [sipIncomingMessages])


    const handleBreak = () => {
        dispatch({
            type: 'SET_BREAK_MODAL',
            payload: true
        })
    }

    return (
        <>
        {/* rewritten - Srini 07-01-25 */}
            {tokenValid === 'Valid' && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: '15px', // Adjusted for better spacing
                    }}
                >
                    {/* <Typography className={classes.agentStatusText}>
                        Agent Status:
                    </Typography>
                    <div className={classes.optionsLayout}>
                        <div
                            style={{
                                borderRadius: '50%',
                                height: '15px',
                                width: '15px',
                                background: sipStatus ? '#41AB1C' : 'red',
                            }}
                        />
                        <Typography className={classes.agentStatusText} style={{ whiteSpace: 'nowrap', marginLeft: '6%' }}>
                            Start Work
                        </Typography>
                        <img
                            src={Frame5}
                            className={classes.iconStyle}
                            onClick={handleBreak}
                            alt="Break Icon"
                        />
                    </div> */}
                    {/* rewritten Srini 07-01-25 */}
                    <div style={{ display: 'flex', gap: '22px', alignItems: 'center' }}>
                        <img src={Frame1} className={classes.iconStyle} alt="Frame1 Icon" />
                        <img src={Frame2} className={classes.iconStyle} alt="Frame2 Icon" />
                        <Tooltip title="Password Reset" arrow slotProps={{
                            popper: {

                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        fontSize: '14px',
                                        backgroundColor: '#131E2E',
                                        color: '#fff',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: '#131E2E',
                                    },
                                },
                            },
                        }}>
                            <IconButton sx={{ color: "white" }} onClick={() => setDrawOpen(true)}>
                                <LockResetIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Logout" arrow slotProps={{
                            popper: {

                                sx: {
                                    '& .MuiTooltip-tooltip': {
                                        fontSize: '14px',
                                        backgroundColor: '#131E2E',
                                        color: '#fff',
                                    },
                                    '& .MuiTooltip-arrow': {
                                        color: '#131E2E',
                                    },
                                },
                            },
                        }}>
                        <img
                            src={Frame3}
                            className={classes.iconStyle}
                            alt="Frame3 Icon"
                            onClick={() => handleLogout(dispatch, navigate)}
                            style={{ cursor: 'pointer'}}
                        />
                        </Tooltip>
                        {/* <img src={Frame4} className={classes.iconStyle} alt="Frame4 Icon" /> */}
                    </div>
                </div>
           )} 
            <BreakModal />
            <ResetPassword open={drawOpen} onClose={() => setDrawOpen(false)} />
        </>
    );
}

export default withStyles(styles)(SipStatus)